import { CustomIconActionRendererComponent } from '../components/grid-renderers/custom-icon-action-renderer.component';
import { SelectFloatingFilterComponent } from '../components/grid-renderers/select-floating-filter.component';

export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/im;

export const SSN_PATTERN = /^\d{5,5}$/;

export const PHONE_NUMBER_PATTERN = /^\d{10,10}$/;

export const PERSONNEL_NUMBER_PATTERN = /^[a-zA-Z]{0,7}[0-9]{1,8}$/;

export const SECURED_OBJECTS_REALMS_MAPPING = [
  { secureObjectName: 'Foodbuy User Management', realm: 'FoodbuyMembers', name: 'Foodbuy Members' },
  { secureObjectName: 'Partner User Management', realm: 'Partners', name: 'Partners' },
  { secureObjectName: 'Compass User Management', realm: 'HourlyAssociates', name: 'Hourly Associates' },
  { secureObjectName: 'Compass User Management', realm: 'TerminatedAssociates', name: 'Separated Associates' },
  { secureObjectName: 'Franchise User Management', realm: 'Franchise', name: 'Franchise Associates' },
  { secureObjectName: 'Client Associates User Management', realm: 'ClientAssociates', name: 'Client Associates' },
  { secureObjectName: 'Distributor User Management', realm: 'Distributors', name: 'Distributors' },
];

export const SECURED_OBJECT_ENABLED_APPLICATIONS = [
  'AAIMS',
  'FMP Distilr',
  'Sitecore'
];

export const ON_PREMISES_DOMAIN_NAME = {
  CANADA: 'Canada.CompassGroup.Corp',
  NA: 'NA.CompassGroup.Corp',
};

export const REALM_DEPENDENT_DETAILS = {
  Franchise: {
    realm: 'Franchise',
    auxClass: 'FranchiseUser',
    accountType: 'FranchiseUser',
    syncData: true,
    externalFilter: true,
    externalFilterBindLabel: 'franchise_name',
    externalFilterBindValue: 'franchise_id',
    externalFilterOptionsFuncName: 'getFranchises',
    externalFilterName: 'franchiseID',
    externalFilterAllOptionName: 'All Franchises',
    passwordResetMessage: 'If not, please contact your Manager.',
    restrictedRoles: ['Franchise Personnel Manager']
  },
  FoodbuyMembers: {
    realm: 'FoodbuyMembers',
    auxClass: 'FoodbuyMemberUser',
    accountType: 'FoodbuyMembers',
    externalFilter: true,
    externalFilterBindLabel: 'organization',
    externalFilterBindValue: 'teamName',
    externalFilterOptionsFuncName: 'getOrganizations',
    externalFilterName: 'organizationName',
    externalFilterAllOptionName: 'All Organizations',
    theme: 'foodbuy',
    logoUrl: 'static/assets/images/MPower-Logo.png',
    passwordResetMessage: 'If not, OneSource and MyOrders users - contact BuySmart for additional support @ (704) 328-3991. All other members - contact <a href="mailto:SMemberExperienceSupport@foodbuy.com">SMemberExperienceSupport@foodbuy.com</a> and make sure to include your Company name, telephone number and a brief description of the issue. We will contact you within one business day.'
  },
  HourlyAssociates: {
    realm: 'HourlyAssociates',
    auxClass: 'HourlyAssociateUser',
    accountType: 'HourlyAssociates',
    logoUrl: 'static/assets/images/compass-group-logo.png',
    passwordResetMessage: 'If not, please contact your Manager.',
    editUserRestriction: 'costCenter',
    costCenterSourceSystemId: [1001, 2010]
  },
  TerminatedAssociates: {
    realm: 'TerminatedAssociates',
    auxClass: 'HourlyAssociateUser',
    accountType: 'TerminatedAssociates',
    logoUrl: 'static/assets/images/compass-group-logo.png',
    passwordResetMessage: 'If not, please contact your Manager.',
    editUserRestriction: null,
    costCenterSourceSystemId: [1001, 2010]
  },
  HospitalMembers: {
    realm: 'HospitalMembers',
    auxClass: 'HospitalMemberUser',
    accountType: 'HospitalMembers',
    theme: 'hospital',
    logoUrl: 'static/assets/images/compass-group-logo.png',
    passwordResetMessage: 'If not, please contact your Manager.',
    supportURL: 'mailto:MyMalnutritionTools@IamMorrison.com'
  },
  Partners: {
    realm: 'Partners',
    auxClass: 'Partners',
    accountType: 'Partners',
    theme: 'partners',
    costCenterSourceSystemId: [1001, 2010],
    logoUrl: 'static/assets/images/compass-group-logo.png',
    passwordResetMessage: 'If not, please contact your Manager.',
    editUserRestriction: 'costCenter'
  },
  Distributors: {
    realm: 'Distributors',
    auxClass: 'DistributorUser',
    accountType: 'Distributors',
  },
  ClientAssociates: {
    realm: 'ClientAssociates',
    auxClass: 'ClientAssociateUser',
    accountType: 'ClientAssociates',
    theme: 'partners',
    logoUrl: 'static/assets/images/compass-group-logo.png',
    passwordResetMessage: 'If not, please contact your Manager.',
    adminRoles: [
      'Admin',
      'LMS Support'
    ],
  }
};

export const COMMON_GRID_OPTIONS = {
  defaultColDef: {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'contains' },
    floatingFilterComponentParams: { suppressFilterButton: true },
    resizable: true,
    columnsMenuParams: { suppressColumnFilter: true },
    menuTabs: ['generalMenuTab', 'columnsMenuTab']
  },
  pagination: true,
  paginationPageSize: 20,
  rowModelType: 'serverSide',
  cacheBlockSize: 20,
  maxBlocksInCache: 1,
  maxConcurrentDatasourceRequests: 1,
  floatingFilter: true,
  animateRows: true,
  suppressCellSelection: true,
  suppressRowClickSelection: true,
  frameworkComponents: {
    CustomActionRenderer: CustomIconActionRendererComponent,
    selectFloatingFilterComponent: SelectFloatingFilterComponent
  }
};

export const COMMON_GRID_COLUMNS = [
  {
    field: '',
    headerName: 'Edit',
    width: 70,
    filter: false,
    sortable: false,
    suppressMenu: true,
    cellRendererSelector: () => {
      return {
        component: 'CustomActionRenderer',
        params: {
          disabled: false,
          iconClass: 'far fa-pencil',
          actionName: 'editRecord'
        }
      };
    }
  },
  {
    field: '',
    headerName: 'Enable/Disable Account',
    width: 115,
    filter: false,
    sortable: false,
    suppressMenu: true,
    cellRendererSelector: (params) => {
      return {
        component: 'CustomActionRenderer',
        params: {
          disabled: false,
          iconClass: params.data ? params.data.account_locked ? 'far fa-lock-alt' : 'far fa-lock-open-alt' : null,
          actionName: 'enableDisableUser'
        }
      };
    }
  },
  {
    field: '',
    headerName: 'Reset Security',
    width: 80,
    filter: false,
    sortable: false,
    suppressMenu: true,
    cellRendererSelector: () => {
      return {
        component: 'CustomActionRenderer',
        params: {
          disabled: false,
          iconClass: 'far fa-cog',
          actionName: 'resetSecurity'
        }
      };
    }
  },
  {
    field: 'username',
    headerName: 'Username',
    hide: false,
    minWidth: 150
  },
  {
    field: 'email',
    headerName: 'Email Address',
    minWidth: 150
  },
  {
    field: 'firstName',
    headerName: 'First Name',
    minWidth: 100
  },
  {
    field: 'lastName',
    headerName: 'Last Name',
    minWidth: 100
  },
  {
    field: 'status',
    minWidth: 60,
    headerName: 'Status',
    floatingFilterComponent: 'selectFloatingFilterComponent',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    }
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone No',
    minWidth: 100
  },
  {
    field: 'key',
    headerName: 'User Key',
    minWidth: 150,
    hide: true
  },
  {
    field: 'changePwdDate',
    headerName: 'Password Change Date',
    minWidth: 160,
    sortable: false,
    hide: true
  },
  {
    field: 'creationDate',
    minWidth: 160,
    sortable: false,
    hide: true
  },
  {
    field: 'creator',
    headerName: 'Created By',
    minWidth: 150,
    hide: true
  },
  {
    field: 'lastChangeDate',
    headerName: 'Modified Date',
    minWidth: 150,
    sortable: false,
    hide: true
  },
  {
    field: 'lastModifier',
    headerName: 'Modified By',
    minWidth: 150,
    hide: true
  },
];

export const REALM_DEPENDENT_GRID_COLUMNS = {
  Franchise: [
    {
      field: 'costCenterName',
      headerName: 'Cost Center',
      minWidth: 100
    },
    {
      field: 'franchiseName',
      headerName: 'Franchise',
      minWidth: 100,
      filter: false
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
  ],
  Partners: [
    {
      field: 'costCenterName',
      headerName: 'Cost Center',
      minWidth: 100
    },
    {
      field: 'companyName',
      headerName: 'Company',
      minWidth: 100
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
  ],
  ClientAssociates: [
    {
      field: 'costCenterDescription',
      headerName: 'Cost Center Description',
      minWidth: 100,
      hide: true
    },
    {
      field: 'costCenterName',
      headerName: 'Cost Center',
      width: 130
    },
    {
      field: 'jobCode',
      headerName: 'Job Code',
      width: 130
    },
    {
      field: 'hireDate',
      headerName: 'Hire Date',
      width: 110
    },
    {
      field: 'clientAssociateID',
      headerName: 'Client Associate ID',
      width: 150
    },
    {
      field: 'managerPersonnelNumber',
      headerName: 'Manager Personnel Number',
      minWidth: 100,
      hide: true
    },
    {
      field: 'managerLastName',
      headerName: 'Manager Last Name',
      minWidth: 100,
      hide: true
    },
    {
      field: 'managerFirstName',
      headerName: 'Manager First Name',
      minWidth: 100,
      hide: true
    },
    {
      field: 'managerEmail',
      headerName: 'Manager Email',
      minWidth: 160
    },
    {
      field: 'middleName',
      headerName: 'Middle Name',
      minWidth: 100,
      hide: true
    },
  ],
  FoodbuyMembers: [
    {
      field: 'organizationDescription',
      headerName: 'Organization',
      minWidth: 100
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
    {
      field: 'employeeId',
      headerName: 'Employee Id',
      minWidth: 100,
      hide: true
    },
  ],
  Distributors: [
    {
      field: 'distributorOrgName',
      headerName: 'Distributor',
      minWidth: 100
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
  ],
  HourlyAssociates: [
    {
      field: '',
      headerName: 'Resync',
      width: 80,
      filter: false,
      sortable: false,
      suppressMenu: true,
      cellRendererSelector: () => {
        return {
          component: 'CustomActionRenderer',
          params: {
            disabled: false,
            iconClass: 'fas fa-repeat',
            actionName: 'resync'
          }
        };
      },
      columnNumber: 3,
      columnPriority: 0,
    },
    {
      field: 'costCenterName',
      headerName: 'Cost Center',
      minWidth: 100,
      columnNumber: 8,
      columnPriority: 0,
    },
    {
      field: 'costCenterDescription',
      headerName: 'Cost Center Decription',
      minWidth: 100,
      columnNumber: 9,
      columnPriority: 0,
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
    {
      field: 'sectorDescription',
      headerName: 'Sector',
      minWidth: 100
    }, {
      field: 'regionDescription',
      headerName: 'Region',
      minWidth: 100
    }, {
      field: 'divisionDescription',
      headerName: 'Division',
      minWidth: 100
    }, {
      field: 'managerFirstName',
      headerName: 'Manager First Name',
      minWidth: 100
    },
    {
      field: 'managerLastName',
      headerName: 'Manager Last Name',
      minWidth: 100,
    },
    {
      field: 'hireDate',
      headerName: 'Hire Date',
      minWidth: 100,
      hide: true
    },
  ],

  TerminatedAssociates: [
    {
      field: '',
      headerName: 'Resync',
      width: 80,
      filter: false,
      sortable: false,
      suppressMenu: true,
      cellRendererSelector: () => {
        return {
          component: 'CustomActionRenderer',
          params: {
            disabled: false,
            iconClass: 'fas fa-repeat',
            actionName: 'resync'
          }
        };
      },
      columnNumber: 3,
      columnPriority: 0,
    },
    {
      field: 'terminatedPersonnelNumber',
      headerName: 'Personnel Number',
      minWidth: 50,
      columnNumber: 6,
      columnPriority: 0,
    },
    {
      field: 'costCenterName',
      headerName: 'Cost Center',
      minWidth: 100,
      columnNumber: 9,
      columnPriority: 0,
    },
    {
      field: 'costCenterDescription',
      headerName: 'Cost Center Decription',
      minWidth: 100,
      columnNumber: 10,
      columnPriority: 0,
    },
    {
      field: 'jobTitle',
      headerName: 'Job Title',
      minWidth: 100
    },
    {
      field: 'sectorDescription',
      headerName: 'Sector',
      minWidth: 100
    }, {
      field: 'regionDescription',
      headerName: 'Region',
      minWidth: 100
    }, {
      field: 'divisionDescription',
      headerName: 'Division',
      minWidth: 100
    }, {
      field: 'managerFirstName',
      headerName: 'Manager First Name',
      minWidth: 100
    },
    {
      field: 'managerLastName',
      headerName: 'Manager Last Name',
      minWidth: 100,
    },
    {
      field: 'hireDate',
      headerName: 'Hire Date',
      minWidth: 100,
      hide: true
    },
  ],
};

export const AAIMS_CONSTANTS = {
  MODAL_ACTION_ADD: 'ADD'
};

export const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;

export const ANSWER_CHARACTER_SET = /[a-zA-Z0-9_\-\+\.]/

export const COMPASS_REALM = 'CompassAzureAD';

export const ENCRYPTED_FIELDS = ['dateOfBirth', 'last4SSN'];

export const NON_CC_SECURITY_REALMS = ['FoodbuyMembers', 'Franchise'];

export const SERVICE_PHRASE = 'Pp9UpCxPSrAsOaIcDgWjb2kE7OlBgRHNGTy4ygahUaAz4we8lKtPL9yXKvq5mqBS';

export const HOURLY_USER_DOMAINS = [
  'cgnaidmdev.onmicrosoft.com',
  'cgnaidmstaging.onmicrosoft.com',
  'compassassociate.com'
];

export const UPDATE_USER_BODY = {
  "@class": "org.apache.syncope.common.lib.patch.UserPatch",
  "key": "",
  "username": {
    "operation": "ADD_REPLACE"
  },
  "password": {
    "operation": "ADD_REPLACE",
    "value": "",
    "onSyncope": true,
    "resources": []
  },
  "securityQuestion": {
    "operation": "ADD_REPLACE",
    "value": ""
  },
  "securityAnswer": {
    "operation": "ADD_REPLACE",
    "value": ""
  },
  "mustChangePassword": {
    "operation": "ADD_REPLACE",
    "value": true
  },
  "plainAttrs": []
};

export const UPDATE_ATTRS_OBJECT = {
  "operation": "ADD_REPLACE",
  "attrTO": {
    "schemaInfo": {
      "@class": "org.apache.syncope.common.lib.to.PlainSchemaTO",
      "key": "",
      "anyTypeClass": ""
    },
    "schema": "",
    "values": []
  }
};

export const ADAMS_TEMP_ASSOCIATES = 'Compass Paid Temp';

export const ADD_USER_BODY = {
  "@class": "org.apache.syncope.common.lib.to.UserTO",
  "creator": "essadmin",
  "creationDate": "",
  "lastModifier": "essadmin",
  "lastChangeDate": "",
  "key": null,
  "type": "USER",
  "realm": "",
  "status": "active",
  "password": null,
  "token": null,
  "tokenExpireTime": null,
  "username": "",
  "lastLoginDate": null,
  "changePwdDate": null,
  "failedLogins": 0,
  "securityQuestion": null,
  "securityAnswer": null,
  "mustChangePassword": true,
  "dynRealms": [],
  "auxClasses": [],
  "plainAttrs": [],
  "derAttrs": [],
  "virAttrs": [],
  "resources": [],
  "roles": [],
  "dynRoles": [],
  "relationships": [],
  "memberships": [],
  "dynMemberships": []
};

export const ADD_ATTRS_OBJECT = {
  "schemaInfo": {
    "@class": "org.apache.syncope.common.lib.to.PlainSchemaTO",
    "key": "",
    "anyTypeClass": ""
  },
  "schema": "",
  "values": []
};

export const DEFAULT_US_JOB_CODE = {
  code: "clientassociate",
  description: "Client Associates US"
};

export const DEFAULT_CA_JOB_CODE = {
  code: "clientassociateca",
  description: "Client Associates CA"
};

export const LANGUAGE_OPTIONS = [
  {
    "language_name": "English - US",
    "language_name_locale": "English",
    "language_abbr": "en-US"
  },
  {
    "language_name": "Spanish",
    "language_name_locale": "Español",
    "language_abbr": "es"
  },
  {
    "language_name": "French",
    "language_name_locale": "Français",
    "language_abbr": "fr"
  }
];

export const FOODBUY_CONSTANTS = {
  EmployeeID_Required_Organizations: [
    "DIV-CLV-39830"
  ]
};

export const DISTRIBUTORS_CONSTANTS = {
  SOURCE_SYSTEM_ID: [7000, 7001],
};

export const COMPASS_DOMAINS = ['compass-usa', 'iammorrison', 'levyrestaurants', 'cafebonappetit',
  'iamtouchpoint', 'crothall', 'sscserv', 'compass-canada'];
export const EMAIL_REGEX = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)+$/;
